import type { IconsNames } from '@eqi-investimentos/icons/web';
import { Flex, Link, Text } from '@eqi-investimentos/react';
import { useT } from '@/libs/i18n/utils/useT';
import { appsStoreLinks } from '@/config/appsStoreLinks';
import { Icon } from '@/components/elements/Icon';
import { Thumb } from '@/components/elements/Thumb';

export const InfoDownloadApp = () => {
  const t = useT();

  return (
    <Flex
      display={{ base: 'none', lg: 'flex' }}
      flexDir="column"
      alignItems="center"
      justifyContent="center"
      w="21rem"
      h="full"
      p="m"
      gap="5xl"
      bg="background.secondary"
      borderRadius="2xs"
    >
      <Flex flexDir="column" gap="m">
        <Text size="xl" color="content.brand">
          {t('screens.login.downloadApp.title')}
        </Text>
        <Text size="l">{t('screens.login.downloadApp.subTitle')}</Text>
      </Flex>
      <Thumb
        src="/assets/images/qr-code-download-app.png"
        width={208}
        height={208}
        full
        alt="QR Code download app"
      />
      <Flex alignItems="center" gap="s">
        {linkIcons.map((icon) => (
          <Link key={icon} href={appsStoreLinks.unique}>
            <Icon
              iconName={icon}
              color="content.brand"
              width={25}
              height={25}
            />
          </Link>
        ))}
      </Flex>
    </Flex>
  );
};

const linkIcons = ['GooglePlayStore', 'AppStoreOutline'] as IconsNames[];
